/**
 * Pontos de via ruim: onde o acelerômetro levou solavanco forte.
 *
 * Este é o uso do eco-driving que **não depende de calibrar nada**: buraco é
 * buraco, e o pico vertical georreferenciado aponta direto para manutenção de
 * via e de suspensão. Os outros eixos ainda dependem de saber se o equipamento
 * está censurando o longitudinal — este não.
 */
import { CircleMarker, Tooltip } from "react-leaflet";
import { formatG, roadPoints, ROAD_BUMP_CG } from "../lib/eco.ts";
import { formatTime } from "../lib/format.ts";
import type { TelemetryRow } from "../lib/schemas.ts";

/** Pior solavanco esperado, para escalar o raio. 2,5 g foi o máximo medido. */
const WORST_CG = 250;

export function RoadLayer({ rows }: { rows: readonly TelemetryRow[] }) {
  const points = roadPoints(rows);
  if (points.length === 0) return null;

  return (
    <>
      {points.map((point) => {
        // Raio pela severidade: um buraco de 2 g tem que saltar sobre um de
        // 0,6 g. Sem isso o mapa vira mancha uniforme e não aponta nada.
        const intensity = Math.min(1, (point.bumpCg - ROAD_BUMP_CG) / (WORST_CG - ROAD_BUMP_CG));
        return (
          <CircleMarker
            key={`${point.at}-${point.lat}-${point.lon}`}
            center={[point.lat, point.lon]}
            radius={5 + intensity * 9}
            pathOptions={{
              color: "#f97316",
              weight: 1,
              opacity: 0.9,
              fillColor: "#f97316",
              // Aqui a transparência é proposital e não é enfeite: pontos
              // próximos SOMAM, e é isso que faz um trecho ruim aparecer como
              // mancha mais forte que um buraco isolado.
              fillOpacity: 0.25,
            }}
          >
            <Tooltip direction="top" offset={[0, -4]} opacity={1}>
              <span className="text-[11px]">
                Solavanco {formatG(point.bumpCg)} · {formatTime(point.at)}
              </span>
            </Tooltip>
          </CircleMarker>
        );
      })}
    </>
  );
}
